/*
 *
 * Do not edit directly
 * Generated on Mon, 24 Jun 2024 16:18:26 GMT
 *
 */

import PaletteIconAdd from '@telus-uds/palette-allium/build/rn/icons/Add'
import PaletteIconSubtract from '@telus-uds/palette-allium/build/rn/icons/Subtract'
import PaletteIconClose from '@telus-uds/palette-allium/build/rn/icons/Close'
import PaletteIconExpand from '@telus-uds/palette-allium/build/rn/icons/Expand'
import PaletteIconCaretDown from '@telus-uds/palette-allium/build/rn/icons/CaretDown'
import PaletteIconCaretUp from '@telus-uds/palette-allium/build/rn/icons/CaretUp'
import PaletteIconChevronLeft from '@telus-uds/palette-allium/build/rn/icons/ChevronLeft'
import PaletteIconChevronRight from '@telus-uds/palette-allium/build/rn/icons/ChevronRight'
import PaletteIconPlayVideo from '@telus-uds/palette-allium/build/rn/icons/PlayVideo'
const theme = {
  appearances: {
    action: {
      type: 'variant',
      values: [
        'add',      'close',
        'expand',   'moveDown',
        'moveLeft', 'moveRight',
        'moveUp',   'play',
        'subtract'
      ]
    },
    compact: {
      description: 'Without the outer border gap',
      type: 'variant',
      values: [ true ]
    },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    inverse: {
      description: 'For use on dark backgrounds',
      type: 'variant',
      values: [ true ]
    },
    password: {
      description: 'Password masked or not',
      type: 'variant',
      values: [ true ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    raised: {
      description: 'Uses shadow and background colour to appear raised above the page',
      type: 'variant',
      values: [ true ]
    },
    size: { type: 'variant', values: [ 'small', 'large' ] }
  },
  rules: [
    { if: { action: 'add' }, tokens: { icon: PaletteIconAdd } },
    {
      if: { action: 'subtract' },
      tokens: { icon: PaletteIconSubtract }
    },
    { if: { action: 'close' }, tokens: { icon: PaletteIconClose } },
    { if: { action: 'expand' }, tokens: { icon: PaletteIconExpand } },
    {
      if: { action: 'moveDown' },
      tokens: { icon: PaletteIconCaretDown }
    },
    {
      if: { action: 'moveUp' },
      tokens: { icon: PaletteIconCaretUp }
    },
    {
      if: { action: 'moveLeft' },
      tokens: { icon: PaletteIconChevronLeft }
    },
    {
      if: { action: 'moveRight' },
      tokens: { icon: PaletteIconChevronRight }
    },
    {
      if: { action: 'play' },
      tokens: { icon: PaletteIconPlayVideo }
    },
    { if: { action: 'add' }, tokens: { icon: PaletteIconAdd } },
    {
      if: { action: 'subtract' },
      tokens: { icon: PaletteIconSubtract }
    },
    { if: { action: 'close' }, tokens: { icon: PaletteIconClose } },
    { if: { action: 'expand' }, tokens: { icon: PaletteIconExpand } },
    {
      if: { action: 'moveDown' },
      tokens: { icon: PaletteIconCaretDown }
    },
    {
      if: { action: 'moveUp' },
      tokens: { icon: PaletteIconCaretUp }
    },
    {
      if: { action: 'moveLeft' },
      tokens: { icon: PaletteIconChevronLeft }
    },
    {
      if: { action: 'moveRight' },
      tokens: { icon: PaletteIconChevronRight }
    },
    {
      if: { action: 'play' },
      tokens: { icon: PaletteIconPlayVideo }
    },
    {
      if: { inverse: true },
      tokens: { borderColor: '#ffffff', iconColor: '#ffffff' }
    },
    {
      if: { hover: true },
      tokens: { borderColor: '#414547', iconColor: '#414547', iconScale: 1.1 }
    },
    { if: { hover: true }, tokens: { iconScale: 1 } },
    {
      if: { hover: true, password: true },
      tokens: {
        backgroundColor: '#7c53a5',
        borderColor: '#7c53a5',
        iconColor: '#ffffff'
      }
    },
    { if: { password: true }, tokens: { borderColor: 'transparent' } },
    {
      if: { focus: true, password: true },
      tokens: { borderColor: '#4b286d' }
    },
    {
      if: { hover: true, inverse: true },
      tokens: { borderColor: '#ffffff', iconColor: '#ffffff' }
    },
    {
      if: { focus: true },
      tokens: {
        outerBorderColor: '#676e73',
        outerBorderGap: 4,
        outerBorderWidth: 1
      }
    },
    {
      if: { focus: true, password: true },
      tokens: {
        borderWidth: 3,
        outerBorderColor: '#3f2a54',
        outerBorderWidth: 0
      }
    },
    {
      if: { focus: true, inverse: true },
      tokens: {
        backgroundColor: 'transparent',
        borderColor: '#ffffff',
        iconColor: '#ffffff',
        outerBorderColor: '#ffffff',
        outerBorderWidth: 1
      }
    },
    {
      if: { pressed: true },
      tokens: {
        backgroundColor: '#676e73',
        borderColor: '#ffffff',
        iconColor: '#ffffff',
        outerBorderGap: 4
      }
    },
    {
      if: { password: true, pressed: true },
      tokens: {
        backgroundColor: '#3f2a54',
        borderColor: '#3f2a54',
        iconColor: '#ffffff',
        outerBorderGap: 0
      }
    },
    {
      if: { inverse: true, pressed: true },
      tokens: {
        backgroundColor: 'rgba(255, 255, 255, 0.4)',
        borderColor: '#ffffff',
        iconColor: '#ffffff',
        outerBorderWidth: 0
      }
    },
    { if: { size: 'large' }, tokens: { iconSize: 24, padding: 12 } },
    { if: { size: 'small' }, tokens: { iconSize: 16, padding: 4 } },
    {
      description: 'Raised IconButtons follow different design patterns to other variants',
      if: { raised: true },
      tokens: {
        backgroundColor: '#ffffff',
        borderColor: '#b2b9bf',
        borderWidth: 1,
        iconSize: 16,
        outerBorderColor: 'transparent',
        outerBorderGap: 0,
        outerBorderWidth: 0,
        padding: 8,
        shadow: {
          blur: 2,
          color: 'rgba(0, 0, 0, 0.2)',
          inset: false,
          offsetX: 0,
          offsetY: 2,
          spread: 0
        }
      }
    },
    {
      if: { raised: true, size: 'large' },
      tokens: { iconSize: 24, padding: 12 }
    },
    { if: { raised: true, size: 'small' }, tokens: { padding: 8 } },
    {
      if: { pressed: true, raised: true },
      tokens: { backgroundColor: '#676e73', borderWidth: 0 }
    },
    {
      if: { inactive: true, password: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderWidth: 0,
        iconColor: '#e3e6e8',
        outerBorderColor: 'rgba(0, 0, 0, 0)'
      }
    },
    {
      if: { hover: true, raised: true },
      tokens: { borderColor: '#b2b9bf', borderWidth: 3 }
    },
    {
      if: { focus: true, raised: true },
      tokens: { borderColor: '#4b286d', borderWidth: 3, iconColor: '#4b286d' }
    },
    {
      if: { focus: true, pressed: true, raised: true },
      tokens: {
        backgroundColor: '#4b286d',
        borderWidth: 0,
        iconColor: '#ffffff'
      }
    },
    { if: { compact: true }, tokens: { outerBorderGap: 0 } }
  ],
  tokens: {
    backgroundColor: 'transparent',
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    borderBottomWidth: null,
    borderColor: '#676e73',
    borderLeftWidth: null,
    borderRadius: 99999999999999,
    borderRightWidth: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderTopWidth: null,
    borderWidth: 1,
    height: null,
    icon: PaletteIconAdd,
    iconColor: '#676e73',
    iconScale: 1,
    iconSize: 16,
    iconTranslateX: 0,
    iconTranslateY: 0,
    outerBorderColor: 'transparent',
    outerBorderGap: 0,
    outerBorderWidth: null,
    padding: 4,
    shadow: null,
    width: null
  }
}
export default theme
